import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Home Assistant MQTT Auto-Discovery",
  "path": "/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/",
  "dateChanged": "2025-11-25",
  "author": "Mike Polinowski",
  "excerpt": "Home Assistant unterztüzt das automatische Hinzufügen von neuen Geräten über MQTT - das sog. MQTT Discovery. Dies erlaubt Ihnen das automatische Hinzufügen Ihrer INSTAR Kamera als Home Assistant Gerät!",
  "image": "../FAQ_SearchThumb.png",
  "social": "/images/Search/FAQ_SearchThumb.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_FAQs_white.webp",
  "chapter": "FAQs",
  "faq": "WQHD & UHD Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEOHelmet title='Home Assistant MQTT Auto-Discovery' dateChanged='2025-11-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Home Assistant unterztüzt das automatische Hinzufügen von neuen Geräten über MQTT - das sog. MQTT Discovery. Dies erlaubt Ihnen das automatische Hinzufügen Ihrer INSTAR Kamera als Home Assistant Gerät!' image='/images/Search/FAQ_SearchThumb.png' twitter='/images/Search/FAQ_SearchThumb.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/' locationFR='/fr/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/' crumbLabel="FAQs" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "home-assistant-mqtt-auto-discovery",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#home-assistant-mqtt-auto-discovery",
        "aria-label": "home assistant mqtt auto discovery permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Home Assistant MQTT Auto-Discovery`}</h1>
    <p>{`Home Assistant unterztüzt das automatische Hinzufügen von neuen Geräten über MQTT - das sog. `}<a parentName="p" {...{
        "href": "https://www.home-assistant.io/integrations/mqtt#mqtt-discovery"
      }}>{`MQTT Discovery`}</a>{`.`}</p>
    <p>{`Alles was Sie dafür tun müssen, ist die Kamera mit dem gleichen MQTT Broker zu verbinden, den Sie auch in Home Assistant eingebunden haben - fertig!`}</p>
    <p>{`Wenn Sie noch kein MQTT nutzen, folgen Sie einfach diesen einfachen Schritten, um die Kamera in Home Assistant hinzuzufügen.`}</p>
    <h2 {...{
      "id": "hinzufügen-der-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#hinzuf%C3%BCgen-der-kamera",
        "aria-label": "hinzufügen der kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hinzufügen der Kamera`}</h2>
    <h3 {...{
      "id": "konfiguration-des-kamera-mqtt-brokers",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfiguration-des-kamera-mqtt-brokers",
        "aria-label": "konfiguration des kamera mqtt brokers permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfiguration des Kamera MQTT Brokers`}</h3>
    <p>{`Zuerst muss in der Kamera der MQTT Broker aktiviert werden. Diesen Konfiguration finden Sie in der Weboberfläche unter `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/MQTT/"
      }}>{`Smathome/MQTT`}</a>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/451fce97b46a17a76d1fec29278535f2/30cf6/HA_Auto_Discovery_01.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "93.91304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB5l6XTNkKRMCP/8QAGRAAAwADAAAAAAAAAAAAAAAAAQIQABEg/9oACAEBAAEFAlhGLxsz/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAHBAAAgICAwAAAAAAAAAAAAAAAAERMSGREFFh/9oACAEBAAE/Iasx0tCG8IqzZJLVM9Hx/9oADAMBAAIAAwAAABCj/wA//8QAFhEAAwAAAAAAAAAAAAAAAAAAAREg/9oACAEDAQE/EEI//8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQIBAT8QFj//xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMUFRgbHB8f/aAAgBAQABPxAjaDk2TB9CJ2rrbzPFjV5OyWFpdwK2F7pn2pU//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/451fce97b46a17a76d1fec29278535f2/e4706/HA_Auto_Discovery_01.avif 230w", "/de/static/451fce97b46a17a76d1fec29278535f2/d1af7/HA_Auto_Discovery_01.avif 460w", "/de/static/451fce97b46a17a76d1fec29278535f2/7f308/HA_Auto_Discovery_01.avif 920w", "/de/static/451fce97b46a17a76d1fec29278535f2/85cc3/HA_Auto_Discovery_01.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/451fce97b46a17a76d1fec29278535f2/a0b58/HA_Auto_Discovery_01.webp 230w", "/de/static/451fce97b46a17a76d1fec29278535f2/bc10c/HA_Auto_Discovery_01.webp 460w", "/de/static/451fce97b46a17a76d1fec29278535f2/966d8/HA_Auto_Discovery_01.webp 920w", "/de/static/451fce97b46a17a76d1fec29278535f2/409e5/HA_Auto_Discovery_01.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/451fce97b46a17a76d1fec29278535f2/e83b4/HA_Auto_Discovery_01.jpg 230w", "/de/static/451fce97b46a17a76d1fec29278535f2/e41a8/HA_Auto_Discovery_01.jpg 460w", "/de/static/451fce97b46a17a76d1fec29278535f2/4d836/HA_Auto_Discovery_01.jpg 920w", "/de/static/451fce97b46a17a76d1fec29278535f2/30cf6/HA_Auto_Discovery_01.jpg 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/451fce97b46a17a76d1fec29278535f2/4d836/HA_Auto_Discovery_01.jpg",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Überprüfen Sie hier noch die Klienten Einstellungen im nächsten Tab:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/30cf6/HA_Auto_Discovery_02.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABzGRkgpD/xAAXEAADAQAAAAAAAAAAAAAAAAABAhAA/9oACAEBAAEFAlhGW//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGn/8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGhABAQEAAwEAAAAAAAAAAAAAAQARITGx8f/aAAgBAQABPyHq2h8gXj2WDaW3/9oADAMBAAIAAwAAABD8/wD/xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAwEBPxCj/8QAFhEBAQEAAAAAAAAAAAAAAAAAARBB/9oACAECAQE/EBZP/8QAHBABAQEAAQUAAAAAAAAAAAAAAREAMSFRcYGR/9oACAEBAAE/EJag9Tkyrgvhk6Z3vJx031lWt+ahYu//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/e4706/HA_Auto_Discovery_02.avif 230w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/d1af7/HA_Auto_Discovery_02.avif 460w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/7f308/HA_Auto_Discovery_02.avif 920w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/85cc3/HA_Auto_Discovery_02.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/a0b58/HA_Auto_Discovery_02.webp 230w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/bc10c/HA_Auto_Discovery_02.webp 460w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/966d8/HA_Auto_Discovery_02.webp 920w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/409e5/HA_Auto_Discovery_02.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/e83b4/HA_Auto_Discovery_02.jpg 230w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/e41a8/HA_Auto_Discovery_02.jpg 460w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/4d836/HA_Auto_Discovery_02.jpg 920w", "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/30cf6/HA_Auto_Discovery_02.jpg 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/53ccd1bb78ffd149b4f5b04d69d6985b/4d836/HA_Auto_Discovery_02.jpg",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Sie sehen hier das MQTT Discovery Präfix - dieses ist bereits auf homeassistant gelegt. Sollten Sie in Home Assistant ein anderes Präfix für das `}<a parentName="p" {...{
        "href": "https://www.home-assistant.io/integrations/mqtt#mqtt-discovery"
      }}>{`MQTT Discovery`}</a>{` hinterlegt haben, müssen Sie dies hier entsprechend anpassen.`}</p>
    <h3 {...{
      "id": "konfiguration-des-mqtt-klienten-in-home-assistant",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfiguration-des-mqtt-klienten-in-home-assistant",
        "aria-label": "konfiguration des mqtt klienten in home assistant permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfiguration des MQTT Klienten in Home Assistant`}</h3>
    <p>{`Fügen Sie nun in Home Assistant eine `}<a parentName="p" {...{
        "href": "https://www.home-assistant.io/integrations/mqtt"
      }}>{`MQTT integration`}</a>{` hinzu:`}</p>
    <p><img parentName="p" {...{
        "src": "./HA_Auto_Discovery_03.jpg",
        "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras"
      }}></img></p>
    <p>{`Die Daten hier sind die, die Sie zuvor in der Kamera für den MQTT Broker hinterlegt haben - IP Adresse der Kamera, MQTT Port und das Borker Login.`}</p>
    <h3 {...{
      "id": "hinzufügen-des-erkannten-gerätes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#hinzuf%C3%BCgen-des-erkannten-ger%C3%A4tes",
        "aria-label": "hinzufügen des erkannten gerätes permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hinzufügen des erkannten Gerätes`}</h3>
    <p>{`Was als nächstes passiert war in meinen Tests etwas inkonsistent. Im Idealfall wird Ihnen sofort angezeigt, dass ein neues Geräte über MQTT gefunden wurde:`}</p>
    <p><img parentName="p" {...{
        "src": "./HA_Auto_Discovery_04.jpg",
        "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras"
      }}></img></p>
    <p>{`Sollte dies nicht sofort geschehen, warten Sie einfach eine Weile - Home Assistant wird Ihnen unten links eine Benachrichtigung anzeigen, sobald das Geräte erfolgreiche angemeldet ist. Der weiter Verlauf ist dann wieder identisch:`}</p>
    <p>{`Ihnen steht jetzt sofort die vollständige MQTT Schnittstelle der Kamera in Home Assistant zur Verfügung - inklusive der neuen `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/"
      }}>{`AI Anbindung`}</a>{`:`}</p>
    <p><img parentName="p" {...{
        "src": "./HA_Auto_Discovery_05.jpg",
        "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "./HA_Auto_Discovery_06.jpg",
        "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "./HA_Auto_Discovery_07.jpg",
        "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "./HA_Auto_Discovery_08.jpg",
        "alt": "Home Assistant MQTT Discovery INSTAR IP Kameras"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/FAQs/"
        }}>{`FAQs`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9420WQHD/"
            }}>{`IN-9420 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9408WQHD/"
            }}>{`IN-9408 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8415WQHD/"
            }}>{`IN-8415 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8403WQHD/"
            }}>{`IN-8403 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8401WQHD/"
            }}>{`IN-8401 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9020FHD/"
            }}>{`IN-9020 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9010FHD/"
            }}>{`IN-9010 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9008FHD/"
            }}>{`IN-9008 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8015FHD/"
            }}>{`IN-8015 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8003FHD/"
            }}>{`IN-8003 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8001FHD/"
            }}>{`IN-8001 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-7011HD/"
            }}>{`IN-7011 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6014HD/"
            }}>{`IN-6014 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6012HD/"
            }}>{`IN-6012 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6001HD/"
            }}>{`IN-6001 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-5907HD/"
            }}>{`IN-5907 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-5905HD/"
            }}>{`IN-5905 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/VGA_Series/"
            }}>{`VGA Series`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      